import { ComponentInstall } from "../../utils";
import Icon from "./src";

export default ComponentInstall(Icon);
